import { Routes } from '@angular/router'
import { PUBLIC_ROUTES } from './public/public.routes'
import { SECURE_ROUTES } from './secure/secure-routing-module'
import { PublicComponent } from './layouts/public.component'
import { SecureComponent } from './layouts/secure.component'
import { trialGuardFn } from './core/guards/trial.guard'
import { authGuardFn } from '@auth0/auth0-angular'
import { ForbiddenComponent } from './secure/modules/forbidden/forbidden.component'
import { accessTypeGuard } from './core/guards/access-type.guard'
import { defaultPageGuard } from './core/guards/default-page.guard'

export const ROUTES: Routes = [
    { path: '', pathMatch: 'full', canActivate: [authGuardFn, defaultPageGuard], children: [] },
    {
        path: '',
        component: PublicComponent,
        data: { title: 'Public Views' },
        children: PUBLIC_ROUTES,
    },
    {
        path: '',
        component: SecureComponent,
        canActivate: [authGuardFn],
        canActivateChild: [authGuardFn, accessTypeGuard, trialGuardFn],
        data: { title: 'Secure Views' },
        children: SECURE_ROUTES,
    },
    {
        path: 'forbidden',
        component: ForbiddenComponent,
        title: 'Forbidden',
    },
    { path: '**', redirectTo: '/forbidden' },
]

// @NgModule({
//     imports: [
//         RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled', paramsInheritanceStrategy: 'always' }),
//     ],
//     exports: [RouterModule],
// })
// export class AppRoutingModule {}
